import {
  MASTERCRONSCHEDULE_LIST_OVERDUE,
  MASTERCRONSCHEDULE_LIST_OVERDUE_SUCCESS,
  MASTERCRONSCHEDULE_LIST_OVERDUE_FAILURE,
  MASTERCRONSCHEDULE_LIST,
  MASTERCRONSCHEDULE_LIST_SUCCESS,
  MASTERCRONSCHEDULE_LIST_FAILURE,
  MASTERCRONSCHEDULE_REQUESTRUN,
  MASTERCRONSCHEDULE_REQUESTRUN_SUCCESS,
  MASTERCRONSCHEDULE_REQUESTRUN_FAILURE,
} from "./actionType";
const initialState = {
  masterCronScheduleListData: [],
  masterCronScheduleListDataLoading: false,
  masterCronScheduleListDataError: null,

  masterCronScheduleListOverdueData: [],
  masterCronScheduleListOverdueDataLoading: false,
  masterCronScheduleListOverdueDataError: null,

  masterCronScheduleRequestRunData: [],
  masterCronScheduleRequestRunDataLoading: false,
  masterCronScheduleRequestRunDataError: null,
};

//reducer

const cronSchedulesReducer = (state = initialState, action) => {
  switch (action.type) {
    ///mastercronschedule/list/overdue
    case MASTERCRONSCHEDULE_LIST_OVERDUE:
      return {
        ...state,
        masterCronScheduleListOverdueDataLoading: true,
        masterCronScheduleListOverdueDataError: null,
      };
    case MASTERCRONSCHEDULE_LIST_OVERDUE_SUCCESS:
      return {
        ...state,
        masterCronScheduleListOverdueData: action.payload,
        masterCronScheduleListOverdueDataLoading: false,
      };
    case MASTERCRONSCHEDULE_LIST_OVERDUE_FAILURE:
      return {
        ...state,
        masterCronScheduleListOverdueDataError: action.error,
        masterCronScheduleListOverdueDataLoading: false,
      };
    ///mastercronschedule/list
    case MASTERCRONSCHEDULE_LIST:
      return {
        ...state,
        masterCronScheduleListDataLoading: true,
        masterCronScheduleListDataError: null,
      };
    case MASTERCRONSCHEDULE_LIST_SUCCESS:
      return {
        ...state,
        masterCronScheduleListData: action.payload,
        masterCronScheduleListDataLoading: false,
      };
    case MASTERCRONSCHEDULE_LIST_FAILURE:
      return {
        ...state,
        masterCronScheduleListDataError: action.error,
        masterCronScheduleListDataLoading: false,
      };
    ///mastercronschedule/requestrerun/166
    case MASTERCRONSCHEDULE_REQUESTRUN:
      return {
        ...state,
        masterCronScheduleRequestRunDataLoading: true,
        masterCronScheduleRequestRunDataError: null,
      };
    case MASTERCRONSCHEDULE_REQUESTRUN_SUCCESS:
      return {
        ...state,
        masterCronScheduleRequestRunData: action.payload,
        masterCronScheduleRequestRunDataLoading: false,
      };
    case MASTERCRONSCHEDULE_REQUESTRUN_FAILURE:
      return {
        ...state,
        masterCronScheduleRequestRunDataError: action.error,
        masterCronScheduleRequestRunDataLoading: false,
      };
    default:
      return state;
  }
};

export default cronSchedulesReducer;
